import React, { useEffect, useState } from "react";
import { postAgregarDX, postDataCompletaPacienteDQ, postDataParaLuegoUpdateDX, postDescripcionSelect,  postInsertComplicacionesDescripcionQx, postInsertOrUpdateDescripcionqxUnCirujano, postListComplicacionesDescripcionQx,  postSelectCambiarEstadoPaciente, postSelectTextArea, postUpdateDescripcionQuirurgica } from "../../../services/PaginaRuta";
//import Loading from "../../Loading";
import DescripcionQuirurgicaSuccessFull from "../../mensaje/DescripcionQuirurgicaSuccessFull";
import ErrorDescripcionQuirurgica from "./ErrorDescripcionQuirurgica";
import ModalDiagnosticosDescripcionPostOperatorio from "./ModalDiagnosticosDescripcionPostOperatorio";
import ModalDiagnosticosDescripcionQxPreoperatorio from "./ModalDiagnosticosDescripcionQxPreoperatorio";
import ModalListaDeSeleccionDignosticoCodDxCom from "./ModalListaDeSeleccionDignosticoCodDxCom";
import ModalMensajeComplicacion from "./ModalMensajeComplicacion";
import ModalPrincipalListaDiagnosticosPosoperatorio from "./ModalPrincipalListaDiagnosticosPosoperatorio";
import ModalPrincipalListaDiagnosticosPreoperatorio from "./ModalPrincipalListaDiagnosticosPreoperatorio";
import ModalProcedimientoDQX from "./ModalProcedimientoDQX";
import ModalTejidosPatologiaDecripcionQX from "./ModalTejidosPatologiaDecripcionQX";
import TablaCodDxCompDQ from "./TablaCodDxCompDQ";
import ModalDescripcionQXYaSeRealizo from "./ModalDescripcionQXYaSeRealizo";
import { fechaActual } from "../../../hooks/UseDate";
//import { useParams } from 'react-router-dom';
import Select from 'react-select';

const DescripcionCirugiaMedicoTabs = ({  setmodalOnDescripcionQuirurgica,  color, item, setactualizarTablaProcedimientos,passChildCambioDeEstado,seleccionarMedico,passDataActualizarDescripcionQX,handleCancelClickListaProcedimientos, datalistMedico, datalistMedicoSinDuplicados }) => {  
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  //const { token } = useParams(); // Obtén el token de los parámetros de la URL
  //
  //const [filtro, setFiltro] = useState('');
  //const [opcionesFiltradas, setOpcionesFiltradas] = useState([]);
  //
  const [textAreasValues, setTextAreasValues] = useState(
    () =>
      datalistMedicoSinDuplicados.reduce((acc, medico) => {
        acc[medico.MedCod] = medico.DescripcionQx ?? ''; // Asigna la descripción del médico a la clave MedCod
        acc['descripcionQuirurgicaMedico'] = medico.DescripcionQx ?? ''; // Asigna la descripción a una clave estática llamada 'descripcionQuirurgicaMedico'
        return acc;
      }, {})
  );
  //console.log(token);
  //const [dataArrayCirujanos, setdataArrayCirujanos]=useState([])
  const [dataDescripcionQuirurgica, setdataDescripcionQuirurgica]=useState([])
  const [dataUser, setDataUser]=useState([])
  const [codigoEspecialidadM, setcodigoEspecialidadM]=useState([])
  //const [nombreMe, setnombreMe]=useState([])
  const [textAreaQx, settextAreaQx]=useState('')
  const [textAreaQx2, settextAreaQx2]=useState({})
  const [selectedMedCod, setSelectedMedCod] = useState(null);
  //const [nameUser, setnameUser]=useState([]) 
  //const [CodMcdptoUser, setCodMcdptoUser]=useState('')
  //const [ProEmpCodUser, setProEmpCodUser]=useState('')
  const [isComplicaciones, setIsComplicaciones]=useState(false)
  const [complicacionesNS, setcomplicacionesNS]=useState('N')
  const [complicacionTextArea, setcomplicacionTextArea]=useState('')
  const [modalOnDiagnosticoDescripcionPreoperatorio, setmodalOnDiagnosticoDescripcionPreoperatorio] = useState(false);
  const [modalOnDiagnosticoDescripcionPostOperatorio,setmodalOnDiagnosticoDescripcionPostOperatorio] = useState(false);
  const [openTab, setOpenTab] = useState(1);
  const [loading,setloading]=useState(true)
  //const [dataRealizadaDQ,setdataRealizadaDQ]=useState([])
  const [modalOnClickPatologia, setmodalOnClickPatologia]=useState(false)
  const [modalOnPrincipalListaDiagnosticoPreoperatorio, setmodalOnPrincipalListaDiagnosticoPreoperatorio]=useState(false)
  const [modalOnPrincipalListaDiagnosticoPosoperatorio, setmodalOnPrincipalListaDiagnosticoPosoperatorio]=useState(false)
  const [modalOnSeleccionDiagnosticoCodDxCom, setmodalOnSeleccionDiagnosticoCodDxCom]=useState(false)
  const [modalOnMensajeComplicacion, setmodalOnMensajeComplicacion]=useState(false)
  const [modalOnGuardadoExitosamente, setmodalOnGuardadoExitosamente]=useState(false)
  const [modalOnDescripcionQXRealizada, setmodalOnDescripcionQXRealizada]=useState(false)
  const [modalOnError,setmodalOnError]=useState(false)
  const [errorDiagnosticoPreoperatorio, seterrorDiagnosticoPreoperatorio]=useState('')
  const [errorDigagnosticoPostoperatorio, seterrorDigagnosticoPostoperatorio]=useState('')
  const [errorTipoHerida, seterrorTipoHerida]=useState('')
  const [errorFechaInicial, seterrorFechaInicial]=useState('')
  const [errorHoraInicial, seterrorHoraInicial]=useState('')
  const [errorFechaFinal, seterrorFechaFinal]=useState('')
  const [errorHoraFinal, seterrorHoraFinal]=useState('')
  const [errorDescripciónQx, seterrorDescripciónQx]=useState('')
  const [hallazgos2, sethallazgos2]=useState('')
  const [errorDescripciónQx2, seterrorDescripciónQx2]=useState('')
  const [horaInicial,setHoraInicial]=useState('')
  const [horaFinal,setHoraFinal]=useState('')
  //const [fechaActual, setFechaActual]=useState("")
  const [descripcionSelect, setdescripcionSelect]=useState([])
  //const [dataCodDxComp, setdataCodDxComp]= useState([])
  const [dataListComplicaciones, setdataListComplicaciones]=useState([])
  const [actualizarTablaComplicaciones, setactualizarTablaComplicaciones]=useState([])
  //const [validarTextAreaDQ, setvalidarTextAreaDQ]=useState(false)////////////
  const [dataTipoHerida, setdataTipoHerida]=useState('')
  const [dataTipoAnestesia, setdataTipoAnestesia]=useState('')
  const [dataVia, setdataVia]=useState('')
//   const [informacionDataUserDataMedico, setinformacionDataUserDataMedico]=useState({
//     DQxClv:'',
//     DQxCod:'',
//     MMCODM:'',
//     MPCedu:'',
//     MPFchN:'',
//     MPNOMC:'',                                                                                                                                                                                                                             
//     MPSexo:'',
//     MPTDoc:'',
//     ProCirCod:'',
//     ProCons:'',
//     ProCtvIn:'',
//     ProEmpCod:'',
//     ProEspSep:'',
//     ProFec:'',
//     ProFecF:'',
//     ProFliSol:'',
//     ProHorF:'',
//     ProHorI:'',
//     ProIndRei:'',
//     ProMCDpto:'',     
//     ProNcons:'',                                 
//     ProPerSep:''
// })
  const [dataUpdate, setdataUpdate]=useState({
        CodEmpCod: "",
        CodMcdpto: "",
        CodMed: "",
        CodCir: "",
        CedPac: "",
        HorIniCir: "",
        HorFinCir: "",
        DiaEnt: "",
        DiaSal: "",
        TipHer: "",
        CanSan: "",
        TiePer: "",
        TieClamp: "",
        ViaIng: "",
        EstCir: "",
        TipAne: "",
        CscIng: "",
        DQxCod: "",
        DesCir: "",
        DesCom: "",
        CodEsp: "",
        DesDatMUn: "",
        DesInNNIS: "",
        DesIndCom: "",
        DesHalEnc: "",
        DesObsDxE: "",
        DesObsDxS: "",
        DesIndTej: "",
        FECFINCIR: "",
        FECINICIR: "",
        DiaSalDMNomb: "",
        DiaEntDMNomb: ""              
  })
  const [passDataDiagnosticoPreoperatorio, setpassDataDiagnosticoPreoperatorio]=useState({
    
    CodDxPrPo: '',
    DMNomb: ''
  })
  const [passDataDignosticoPostoperatorio, setpassDataDignosticoPostoperatorio]=useState({
    codigoDiagnostico:'',
    nombreDiagnostico:''
  })
  const [passDataDiagnosticoCodDxCom, setpassDataDiagnosticoCodDxCom]=useState({
    codigoDiagnostico:'',
    nombreDiagnostico:''
  })

  const handleOnclickCodDxComp=()=>{
    // if(passDataDiagnosticoCodDxCom.codigoDiagnostico){
    //   setdataCodDxComp([...dataCodDxComp,passDataDiagnosticoCodDxCom])
    //   setpassDataDiagnosticoCodDxCom({})
    // }
    const insertComplicaciones = {
      CodEmpCod:usuarioInfo.Empresa,
      CodMcdpto:usuarioInfo.Sede,
      CodCir: item.ProCirCod,
      CodMed: seleccionarMedico.MedCod,
      DxCompl: passDataDiagnosticoCodDxCom.codigoDiagnostico
    }
    console.log(insertComplicaciones,'insertComplicaciones')
    if(passDataDiagnosticoCodDxCom.codigoDiagnostico !== ''){
      postInsertComplicacionesDescripcionQx(insertComplicaciones).then((res)=>{
        console.log(res.data,'insertado complicaciones')
        setactualizarTablaComplicaciones(insertComplicaciones)
        setpassDataDiagnosticoCodDxCom({
          codigoDiagnostico:'',
          nombreDiagnostico:''
        })
      })
    }
    
  }

  

  const handleOnsubmitguardarDx=(e)=>{
    e.preventDefault()
  

  let fechaIni= e.target.fechaInicio.value
  let splitFecha= fechaIni.split('-')
  let yearIni= splitFecha[0]
  let mesIni=splitFecha[1]
  let diaIni=splitFecha[2]
  let fechaCompleta = `${yearIni}-${mesIni}-${diaIni}`
  
  // Extraer horas y minutos del tiempo
  const [hours, minutes] = e.target.horaFinalDX.value.split(':');
  const horaMinutosSegundosInicio = `${hours}:${minutes}:00`
  
  const [hoursFi, minutesFi] = e.target.holaFinalDX.value.split(':');
  const horaMinutosSegundosFinal = `${hoursFi}:${minutesFi}:00`

  //validar el segundo cirujano a cargo
  //let medicoDos =''
  //let especialidadDos ='' 
  let medicoUnoDiligencioFormulario=''
  let medicoDosDiligencioFormulario=''

  // if(seleccionarMedico.identificarMedico === 'medico dos'){
  //   medicoDosDiligencioFormulario='S'
  //   //medicoDos =seleccionarMedico.MedCod
  //   //especialidadDos = seleccionarMedico.MECodE
  // }else if(seleccionarMedico.identificarMedico === 'medico uno'){
  //   medicoUnoDiligencioFormulario='S'
    
  // }

      let fecha = new Date();
      let mes = `${fecha.getMonth() + 1}`    
      if(mes.length === 1){
            mes = "0" + mes
      }
      let dia = `${fecha.getDate()}`
      if(dia.length === 1){
        dia = "0" + dia
      }

    const guardar={
      CodCir: e.target.idCirugia.value,
      CodMed: seleccionarMedico.ProPerSe1,
      CodMcdpto: usuarioInfo.Sede,//CodMcdptoUser,
      CodEmpCod: usuarioInfo.Empresa,//ProEmpCodUser,
      CedPac: e.target.cedulaPaciente.value,
      HorIniCir: horaMinutosSegundosInicio,
      HorFinCir: horaMinutosSegundosFinal,
      FECINICIR: fechaCompleta + " 00:00:00.000",
      FECFINCIR: fechaCompleta + " 00:00:00.000",
      DiaEnt: e.target.codigoPreOperatorio.value + " ",
      DiaSal: e.target.codigoPostOperatorio.value + " ",
      TipHer: e.target.herida.value,
      CanSan: e.target.cntSangrado.value,
      TiePer: e.target.tiePerfusionMin.value,
      TieClamp: e.target.tempoClampMin.value,
      ViaIng: e.target.viaUBD.value,
      EstCir: "4",
      TipAne: e.target.tipoAnestesia.value,
      CscIng: "1",
      DQxCod: "0",
      //DesCir:e.target.textAreaDes.value,
      DesCir:'',
      DesCir2: textAreaQx2,
      DesCom: e.target.complicacionesTextArea.value,
      CodEsp:seleccionarMedico.ProEspSe1,
      DesDatMUn: "",
      DesObsDxE: e.target.obserPreoperatorio.value,
      DesObsDxS: e.target.obserPostoperatorio.value,
      DesInNNIS: e.target.indiceRiesgoNNIS.value,
      DesIndCom: complicacionesNS,
      DesIndTej: ".",
      //DesHalEnc: e.target.hallazgos.value,
      DesHalEnc: '',
      DesHalEnc2: hallazgos2,
      CodMed2: item.ProPerSe2,
      CodEsp2: item.ProEspSe2,
      DiligencioFormularioCirujanoUno: medicoUnoDiligencioFormulario,
      DiligencioFormularioCirujanoDos: medicoDosDiligencioFormulario,
      Id_cirugia: e.target.idCirugia.value,
      cedula_paciente: e.target.cedulaPaciente.value,
      nombre_cirujano: e.target.nombreMedico.value,
      nombre_paciente: e.target.nombrePaciente.value,
      estado_paciente: 'recuperacion',
      fecha_cambio_estado: `${fecha.getFullYear()}-${mes}-${dia}`,
      hora_cambio_estado: `${fecha.getHours()}:${fecha.getMinutes()}`,
      //DescripcionQx: textAreasValues[seleccionarMedico.MedCod?.trim() ?? ''],
      DescripcionQx: textAreasValues[seleccionarMedico.MedCod],
      cirujanoDescripcionQX: seleccionarMedico.MedCod,
      //HallazgosQx: hallazgosPorMedico[seleccionarMedico.MedCod?.trim() ?? '']
      HallazgosQx: hallazgosPorMedico[seleccionarMedico.MedCod]
    }
       console.log(guardar,'nuenuenuenue')
     

      const verificarData={
        CodCir:`${item.ProCirCod}`
      }

      
      
    //console.log(guardar,'guardar update')
    if(errorDiagnosticoPreoperatorio=='' && errorDigagnosticoPostoperatorio=='' && 
       errorHoraInicial=='' && errorHoraFinal=='' && errorDescripciónQx2 === '' ){
      
      //////////////////validar/////////////
      // postDataParaLuegoUpdateDX(verificarData).then((res)=>{
        //if(seleccionarMedico.cantidadCirujanos === 2){
          postAgregarDX(guardar).then((res)=>{
            passDataActualizarDescripcionQX(guardar)
            setmodalOnGuardadoExitosamente(true)
          })
        // }else if(seleccionarMedico.cantidadCirujanos === 1){
        //   postInsertOrUpdateDescripcionqxUnCirujano(guardar).then((res)=>{
        //     passDataActualizarDescripcionQX(guardar)
        //     setmodalOnGuardadoExitosamente(true)
        //   })
        // }
        

        // if(res.data[0]){
        //   console.log(guardar,'update DXXX')
        //   postUpdateDescripcionQuirurgica(guardar).then((res)=>{
        //     console.log(res.data,'update')
        //     setmodalOnGuardadoExitosamente(true)
        //   })
        // }else{
        //   console.log(guardar,'insert DXXX')
        //   postAgregarDX(guardar).then((res)=>{
            
        //     setmodalOnGuardadoExitosamente(true)
        //   })
        //   passChildCambioDeEstado({
        //     estadoPaciente:'13',
        //     disabledPendiente:true,
        //     disabledReservado:true,
        //     disabledConfirmado:true,
        //     disabledIngresoSala:true,
        //     disabledPreparado:true,
        //     disabledCirugia:true,
        //     disabledRecuperacion:false,
        //     disabledSalida:true,
        //     disabledCancelar:true,
        //     disabledRealizada:true,
        //     disabledFacturada:true
        //     })
  
        //     let fecha = new Date();
        //   let mes = `${fecha.getMonth() + 1}`    
        //   if(mes.length === 1){
        //     mes = "0" + mes
        //   }
        //   let dia = `${fecha.getDate()}`
        //   if(dia.length === 1){
        //     dia = "0" + dia
        //   }
          
        //   const body = {
        //     Id_cirugia: e.target.idCirugia.value,
        //     cedula_paciente: e.target.cedulaPaciente.value,
        //     nombre_cirujano: e.target.nombreMedico.value,
        //     nombre_paciente: e.target.nombrePaciente.value,
        //     estado_paciente: 'recuperacion',
        //     fecha_cambio_estado: `${fecha.getFullYear()}-${mes}-${dia}`,
        //     hora_cambio_estado: `${fecha.getHours()}:${fecha.getMinutes()}`,
        //   };
  
        //     postSelectCambiarEstadoPaciente(body).then((res)=>{
        //       passDataActualizarDescripcionQX(guardar)
        //       setactualizarTablaProcedimientos(guardar)
        //     })
            
        // }
      // })
      
        //cambio de estado
        
    }else{
      setmodalOnError(true)
    }
  }

  const passDataDiaCodDxCom=(data)=>{
    setpassDataDiagnosticoCodDxCom(data)
  }

  const passDataDiaPostoperatorio=(data)=>{
    setpassDataDignosticoPostoperatorio(data)
    seterrorDigagnosticoPostoperatorio('')
  }

  const passDataDiaPreoperatorio=(data)=>{
    //console.log(data,'dataaaaaaJJJJJJJJJJJJJJ')
    setpassDataDiagnosticoPreoperatorio(data)
    seterrorDiagnosticoPreoperatorio('')
  }

  const handleOnclickAgregarDiagnosticoCodDxCom=()=>{
    if(passDataDiagnosticoCodDxCom.codigoDiagnostico !== '' && complicacionTextArea === ''){
      setmodalOnMensajeComplicacion(true)
    }else if(passDataDiagnosticoCodDxCom.codigoDiagnostico !== '' && complicacionTextArea !== ''){

    }
  }

  const handleOnclickSeleccionDiagnosticoCodDxCom=()=>{
    setmodalOnSeleccionDiagnosticoCodDxCom(true)
  }

  const handleOnclickPrincipalListaDiagnosticoPosoperatorio=()=>{
    setmodalOnPrincipalListaDiagnosticoPosoperatorio(true)
  }

  const handleOnclickPrincipalDiagnosticoPreoperatorio=()=>{
    setmodalOnPrincipalListaDiagnosticoPreoperatorio(true)
  }

  const handleOnclickPatologia=()=>{
    setmodalOnClickPatologia(true)
  }

  const handleOnclickDiagnosticoDescripcionPostOperatorio = () => {
    setmodalOnDiagnosticoDescripcionPostOperatorio(true);
  };

  const handleOnclickDiagnosticoDescripcionPreoperatorio = () => {
    setmodalOnDiagnosticoDescripcionPreoperatorio(true);
  };

  const handleCancelClick = () => {
    setmodalOnDescripcionQuirurgica(false);
    handleCancelClickListaProcedimientos()
  };

  

  useEffect(()=>{
    
    ////////////////////////////////////////
    //validar si ya habia hecho la descripcion qx
    const verificarData={
      CodCir:`${item.ProCirCod}`
    }
    postDataParaLuegoUpdateDX(verificarData).then((res)=>{
      console.log(res.data[0],'ya lo realizo')
      
      if(res.data[0]){
        setloading(false)
        setdataDescripcionQuirurgica(res.data[0])
        setdataUpdate(res.data[0])
        setdataTipoHerida(res.data[0].TipHer)
        setdataTipoAnestesia(res.data[0].TipAne)
        setdataVia(res.data[0].ViaIng)        
        //seterrorDiagnosticoPreoperatorio('')
        //seterrorDigagnosticoPostoperatorio('')
        // seterrorTipoHerida('')
        seterrorFechaInicial('')
        //seterrorHoraInicial('')
        seterrorFechaFinal('')
        //seterrorHoraFinal('')
        //seterrorDescripciónQx('')

        setpassDataDiagnosticoPreoperatorio({
          CodDxPrPo: res.data[0].DiaEnt? res.data[0].DiaEnt:'',
          DMNomb: res.data[0].DiaEntDMNomb? res.data[0].DiaEntDMNomb:''
        })
        
        
        setpassDataDignosticoPostoperatorio({
          codigoDiagnostico: res.data[0].DiaSal,
          nombreDiagnostico: res.data[0].DiaSalDMNomb
        })

        // if(seleccionarMedico.identificarMedico === 'medico uno'){
          //validar preoperatorio si llega con informacion
          const validarPreOperatorio = res.data[0].DiaEnt
          const errorMessagePreOperatorio = !validarPreOperatorio || validarPreOperatorio.trim() === '' ? 'Seleccionar un Diagnóstico Preoperatorio':''
          seterrorDiagnosticoPreoperatorio(errorMessagePreOperatorio)

          //validar PostOperatorio  si llega informacion
          const validarPostOperatorio = res.data[0].DiaSal
          const errorMessagePostOperatorio = !validarPostOperatorio || validarPostOperatorio.trim() === ''? 'Seleccionar un Diagnóstico PostOperatorio':''
          seterrorDigagnosticoPostoperatorio(errorMessagePostOperatorio)

          //validar hora inicial
          const validarHoraInicial= res.data[0].HorIniCir
          const errorMenssageHoraInicial= !validarHoraInicial || validarHoraInicial.trim() === ''? 'Seleccionar una Hora Inicial':''
          seterrorHoraInicial(errorMenssageHoraInicial)

          //validar hora final
          const validarHoraFinal = res.data[0].HorFinCir
          const errorMessageHoraFinal = !validarHoraFinal || validarHoraFinal.trim() === ''? 'Seleccionar una Hora Final':''
          seterrorHoraFinal(errorMessageHoraFinal)

          //validar herida
          // const validarHerida= res.data[0].TipHer
          // const errorMessageHerida = !validarHerida || validarHerida.trim() === ''? 'Seleccionar tipo herida':''
          // seterrorTipoHerida(errorMessageHerida)

          //validar text area de descripcion qx
          const validarTextAreaDescripcionQx= res.data[0].DesCir
          const errorMessageDesCir= !validarTextAreaDescripcionQx || validarTextAreaDescripcionQx.trim() === ''? 'Debe ingresar una Descripción de la Cirugía':''
          seterrorDescripciónQx(errorMessageDesCir)
        // }
        // else if(seleccionarMedico.identificarMedico === 'medico dos'){
        //   //validar text area de descripcion qx segundo cirujano
        //   const validarTextAreaDescripcionQx2= res.data[0].DesCir2
        //   const errorMessageDesCir2= !validarTextAreaDescripcionQx2 || validarTextAreaDescripcionQx2.trim() === ''? 'Debe ingresar una Descripción de la Cirugía':''
        //   seterrorDescripciónQx2(errorMessageDesCir2)

        //   //validar hora inicial
        //   const validarHoraInicial= res.data[0].HorIniCir
        //   const errorMenssageHoraInicial= !validarHoraInicial || validarHoraInicial.trim() === ''? 'Seleccionar una Hora Inicial':''
        //   seterrorHoraInicial(errorMenssageHoraInicial)

        //   //validar hora final
        //   const validarHoraFinal = res.data[0].HorFinCir
        //   const errorMessageHoraFinal = !validarHoraFinal || validarHoraFinal.trim() === ''? 'Seleccionar una Hora Final':''
        //   seterrorHoraFinal(errorMessageHoraFinal)
        // }
        


        
        sethallazgos2(res.data[0].DesHalEnc2)
        settextAreaQx2(res.data[0].DesCir2)
        settextAreaQx(res.data[0].DesCir)
        setcomplicacionesNS(res.data[0].DesIndCom? res.data[0].DesIndCom:'N')

        if(res.data[0].DesIndCom === 'S'){
          setIsComplicaciones(true)
        }else{
          setIsComplicaciones(false)
        }
      }else{
        seterrorDiagnosticoPreoperatorio('Seleccionar un Diagnóstico Preoperatorio')
        seterrorDigagnosticoPostoperatorio('Seleccionar un Diagnóstico PostOperatorio')
        //seterrorTipoHerida('Seleccionar tipo herida')
        seterrorFechaInicial('Seleccionar Fecha Inicial')
        seterrorHoraInicial('Seleccionar una Hora Inicial')
        seterrorFechaFinal('Seleccionar una Fecha Final')
        seterrorHoraFinal('Seleccionar una Hora Final')
        seterrorDescripciónQx('Debe ingresar una Descripción de la Cirugía')
        setcomplicacionesNS('N')
      }
    })
    //data user
    // const consultarData ={
    //   varProEmpCod:usuarioInfo.Empresa,
    //   varProMCDpto:usuarioInfo.Sede,
    //   varProCirCod:`${item.ProCirCod}`,
    //   varMPCedu:item.MPCedu,
    //   varMPTDoc:item.MPTDoc,
    //   varMMCODM:seleccionarMedico.MedCod//res.data[0].ProPerSep

    // }
    // console.log(consultarData,'antes union')
    // postDataCompletaPacienteDQ(consultarData).then((res)=>{
    //   //console.log(res.data,'data union')
    //   setTimeout(() => {          
    //     setloading(false)
    //   }, 3000);
    //   if(res.data.length !== 0){
    //     setinformacionDataUserDataMedico(res.data[0])
    //   }
    // })
    
    postDescripcionSelect().then((res)=>{
      //console.log(res.data,'IMPORTANETEEEEEE')
      if(res.data){
        setdescripcionSelect(res.data)
      }
      
    })
  },[])

  useEffect(()=>{
    
    setTimeout(() => {          
      const listComplicaciones={
        CodEmpCod:usuarioInfo.Empresa,
        CodMcdpto:usuarioInfo.Sede,
        CodCir:item.ProCirCod,
        CodMed: seleccionarMedico.MedCod
      }
  
      postListComplicacionesDescripcionQx(listComplicaciones).then((res)=>{
        console.log(res.data,'data complicaciones')
        setdataListComplicaciones(res.data)
      })
    }, 1500);
  },[actualizarTablaComplicaciones])

  // const handleOnchangeDiagnosticoPreoperatorio=(e)=>{
  //   console.log(e.target.value,'e.target.value')
  //   if(e.target.value){
  //     seterrorDiagnosticoPreoperatorio('')
  //   }else{
  //     seterrorDiagnosticoPreoperatorio('Seleccionar un Diagnóstico')
  //   }
  // }

  const handleOnchangeHerida=(e)=>{
    setdataTipoHerida(e.target.value)
    // if(e.target.value !== 'Sin Seleccionar'){
    //   seterrorTipoHerida('')
    // }else{
    //   seterrorTipoHerida('Seleccionar tipo herida')
    // }
  }

  const handleOnChangeTipoAnestesia=(e)=>{
    setdataTipoAnestesia(e.target.value)
  }

  const handleOnchageVia=(e)=>{
    setdataVia(e.target.value)
  }

  const handleOnchangeHoraInicial=(e)=>{       
    setHoraInicial(e.target.value)
    if(horaFinal != ''){       
      let timeInicial = new Date(`${fechaActual()} ${e.target.value}`)
      let timeFinal = new Date(`${fechaActual()} ${horaFinal}`)
      let restaInicialFinal = timeFinal - timeInicial      
      
      if(restaInicialFinal < 0){
        seterrorHoraInicial("Hora Inicial no puede ser mayor a la Hora Final")
        seterrorHoraFinal("")
      }else if(restaInicialFinal == 0){
        seterrorHoraInicial("Hora Inicial no puede ser igual a la Hora Final")
        seterrorHoraFinal("Hora Final no puede ser igual a la Hora Inicial")
      }else if(restaInicialFinal > 0){
        seterrorHoraInicial("")
        seterrorHoraFinal("")
      }        
    }else if(horaFinal == ''){
      seterrorHoraInicial("")      
    }    
  }

  const handleOnchangeHoraFinal=(e)=>{    
    setHoraFinal(e.target.value)
    
    if(horaInicial != ''){
      let timeInicial = new Date(`${fechaActual()} ${horaInicial}`)
      let timeFinal = new Date(`${fechaActual()} ${e.target.value}`)
      let restaInicialFinal= timeFinal - timeInicial
      if(restaInicialFinal < 0){
        seterrorHoraInicial("")
        seterrorHoraFinal("Hora Final no puede ser menor a la Hora Inicial")
      }else if(restaInicialFinal == 0){
        seterrorHoraInicial("Hora Inicial no puede ser igual a la Hora Final")
        seterrorHoraFinal("Hora Final no puede ser igual a la Hora Inicial")
      }else if(restaInicialFinal > 0){
        seterrorHoraInicial("")
        seterrorHoraFinal("")
      }        
    }else if(horaInicial == ''){
      seterrorHoraFinal("")
    }    
  }
  //
  const handleOnchangeDescripcionQXSelect=({value})=>{
    console.log(value,'vemos mirando')
    
      seterrorDescripciónQx('')
      const body={
        varDQxCod:value
      }
      postSelectTextArea(body).then((res)=>{
        //console.log(res.data,'')
        settextAreaQx(res.data[0].DQxDes)
      })
   
  }

  // const handleOnchangeDescripcionQXSelect2=({value})=>{
  //   console.log(value,'vemos mirando')
    
  //     seterrorDescripciónQx2('')
  //     const body={
  //       varDQxCod:value
  //     }
  //     postSelectTextArea(body).then((res)=>{
        
  //       settextAreaQx2(res.data[0].DQxDes)
  //     })
   
  // }
  

  useEffect(() => {
    // Asegúrate de que hay un médico seleccionado
    if (seleccionarMedico && seleccionarMedico.MedCod) {
      // Verifica si la descripción del médico seleccionado está vacía
      const descripcionActual = textAreasValues[seleccionarMedico.MedCod]?.trim();
      
      if (!descripcionActual && seleccionarMedico.MedCod.trim() === seleccionarMedico.MedCod.trim()) {
        seterrorDescripciónQx2('Debe ingresar una Descripción de la Cirugía');
      } else {
        seterrorDescripciónQx2(''); // Limpiar error si la descripción no está vacía
      }
    }
  }, [textAreasValues, seleccionarMedico]);
  //console.log(textAreasValues, ' textAreasValues')


  const handleOnchangeDescripcionQXSelect2 = ({ value }, medico) => {
    //console.log(value, 'vemos mirando');
  
    seterrorDescripciónQx2('');
    const body = {
      varDQxCod: value,
    };
  
    postSelectTextArea(body).then((res) => {
      
        setTextAreasValues((prevState) => ({
          ...prevState,
          [medico.MedCod]: res.data[0].DQxDes,
          'descripcionQuirurgicaMedico': res.data[0].DQxDes
        }));
      
     
    });
  };
  
  
  
  
  
  
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      overflow: 'visible',  // Asegura que el menú no tenga su propio scroll
      maxHeight: '300px',   // Controla la altura máxima del menú
    }),
  };
  
  //

  const handleOnchangeComplicaciones=(e)=>{
    setcomplicacionTextArea(e.target.value)
  }

  const handleOnchangeIsComplicaciones=()=>{    
    setIsComplicaciones(!isComplicaciones)
    if(!isComplicaciones){
      setcomplicacionesNS('S')
      //console.log('si')
    }else{
      //console.log('no')
      setcomplicacionesNS('N')
    }
    
  }

  const handleOnchangeTextDescripcion=(e)=>{
    settextAreaQx(e.target.value)
    seterrorDescripciónQx('')
  }

  // const handleOnchangeTextDescripcion2=(e)=>{
  //   console.log(e.target.value.length,'hallazgoz dos')
  //   settextAreaQx2(e.target.value)
  //   seterrorDescripciónQx2('')
  // }
  //const [textAreaQx2, settextAreaQx2] = useState('');

  //funciona
  const handleOnchangeTextDescripcion2 = (e, medico) => {
    const newValue = e.target.value;
    
      setTextAreasValues((prevState) => ({
        ...prevState,
        [medico.MedCod]: newValue,
        'descripcionQuirurgicaMedico': newValue
      }));
      
    
  
    seterrorDescripciónQx2('');
  };


  // const handleOnchangeTextDescripcion2 = (e, medico) => {
  //   const newValue = e.target.value;
  
  //   // Actualiza el valor del textarea específico
  //   setTextAreasValues((prevState) => ({
  //     ...prevState,
  //     [medico.MedCod]: newValue,
  //   }));
  
  //   // Validación para el mensaje de error
  //   if (!newValue.trim() && seleccionarMedico.MedCod.trim() === medico.MedCod.trim()) {
  //     seterrorDescripciónQx2('Debe ingresar una Descripción de la Cirugía');
  //   } else {
  //     seterrorDescripciónQx2(''); // Limpia el mensaje de error si se empieza a escribir algo
  //   }
  // };
  
  
  //console.log(errorDescripciónQx2, ' errorDescripciónQx2')
  
  
  

  // const hangleOnchangeHallazgos2=(e)=>{
  //   console.log(e.target.value.length,'hallazgoz dos')
  //   sethallazgos2(e.target.value)
  // }

  const [hallazgosPorMedico, setHallazgosPorMedico] = useState(
    () =>
      datalistMedicoSinDuplicados.reduce((acc, medico) => {
        acc[medico.MedCod] = medico.HallazgosQx ?? ''; // Asigna la descripción del médico a la clave MedCod
        acc['HallazgosQx'] = medico.HallazgosQx ?? ''; // Asigna la descripción a una clave estática llamada 'descripcionQuirurgicaMedico'
        return acc;
      }, {})
  );

  //console.log(hallazgosPorMedico, '  hallazgosPorMedico')
  const hangleOnchangeHallazgos2 = (e, medico) => {
    const { value } = e.target;
    //console.log(value.length, 'hallazgoz dos');
    setHallazgosPorMedico((prevState) => ({
      ...prevState,
      [medico.MedCod]: value,
      'HallazgosQx': value
    }));
  };
  
  
  return (
    <>
      <div
        className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto "
        id="exampleModalScrollable"
        tabIndex="-1"
        aria-labelledby="exampleModalScrollableLabel"
        aria-hidden="true"
      >
        <div className="sm:h-[calc(100%)]  mx-auto relative w-auto pointer-events-none  bg-[#f4f6fa]">
          <div className="max-h-full  overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current ">
            
              
              <>
            <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#9e56fe]">
              <ul
                className="flex mb-0 list-none flex-wrap pt-1 pb-1 flex-row"
                role="tablist"
              >
                <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
                  <a
                    className={
                      "text-xs font-bold uppercase px-3 py-2 shadow-lg rounded block leading-normal " +
                      (openTab === 1
                        ? "text-white bg-" + color + "-600"
                        : "text-" + color + "-600 bg-white")
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenTab(1);
                    }}
                    data-toggle="tab"
                    href="#link1"
                    role="tablist"
                  >
                    Descripción Qx
                  </a>
                </li>
                <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
                  <a
                    className={
                      "text-xs font-bold uppercase px-3 py-2 shadow-lg rounded block leading-normal " +
                      (openTab === 2
                        ? "text-white bg-" + color + "-600"
                        : "text-" + color + "-600 bg-white")
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenTab(2);
                    }}
                    data-toggle="tab"
                    href="#link2"
                    role="tablist"
                  >
                    Procedimiento
                  </a>
                </li>
              </ul>
              <button
                type="button"
                onClick={handleCancelClick}
                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div>
            <div className="flex-auto overflow-y-auto relative p-1">
            <form className={openTab === 1 ? "block" : "hidden"} id="link1" onSubmit={handleOnsubmitguardarDx}>
              <div className="flex-auto overflow-y-auto relative p-1">
                <div className="flex flex-row py-1  text-left">
                  
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Código del Médico
                    </label>
                    <input
                    defaultValue={dataDescripcionQuirurgica.ProPerSe1} //codigoEspecialidadM.ProPerSep
                    disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Nombre Médico
                    </label>
                    <input
                    defaultValue={dataDescripcionQuirurgica.NombreCirujanoUno}
                    disabled={true}
                    name="nombreMedico"
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Especialidad Médico
                    </label>
                    <input
                      disabled={true}
                      defaultValue={dataDescripcionQuirurgica.EspecilidadCirujanoUno}
                      name='especialidadUno'
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                {/* {
                  dataDescripcionQuirurgica.ProEspSe2 &&
                  <div className="flex flex-row py-1  text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Código Segundo Cirujano
                    </label>
                    <input
                      disabled={true}
                      defaultValue={dataDescripcionQuirurgica.ProPerSe2} 
                      
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Nombre Segundo Cirujano
                    </label>
                    <input
                    defaultValue={dataDescripcionQuirurgica.NombreCirujanoDos} 
                    disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Especilidad Segundo Cirujano
                    </label>
                    <input
                    defaultValue={dataDescripcionQuirurgica.EspecilidadCirujanoDos}
                    disabled={true}
                    
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                
                } */}
                
              </div>
              <div className="flex-auto overflow-y-auto relative px-1">
                <div className="flex flex-row py-1  text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Cédula del Paciente
                    </label>
                    <input
                      disabled={true}
                      defaultValue={dataDescripcionQuirurgica.MPCedu} //dataUser.MPCedu
                      name='cedulaPaciente'
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Tipo de Documento
                    </label>
                    <input
                      disabled={true}
                      defaultValue={dataDescripcionQuirurgica.MPTDoc} //dataUser.MPTDoc
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Nombre
                    </label>
                    <input
                    disabled={true}
                    defaultValue={dataDescripcionQuirurgica.MPNOMC} //nameUser.MPNOMC
                    name="nombrePaciente"
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
              <div className="flex-auto overflow-y-auto relative px-1">
                <div className="flex flex-row py-2  text-left">
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Fecha Inicio
                    </label>
                    <input
                    defaultValue={dataDescripcionQuirurgica.ProFec? dataDescripcionQuirurgica.ProFec.split(' ')[0]:null} //dataUser.ProFec? dataUser.ProFec.split(' ')[0]:null
                    disabled={true}
                    name='fechaInicio'
                      type="date"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Hora Inicio
                    </label>
                    <input
                      defaultValue={dataDescripcionQuirurgica.ProHorI} //dataUser.ProHorI
                      disabled={true}
                      name='horaInicio'
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Fecha Final
                    </label>
                    <input
                      defaultValue={dataDescripcionQuirurgica.ProFecF? dataDescripcionQuirurgica.ProFecF.split(' ')[0]:null} //dataUser.ProFecF? dataUser.ProFecF.split(' ')[0]:null
                      disabled={true}
                      name='fechaFinal'
                      type="date"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Hora Final
                    </label>
                    <input
                      defaultValue={dataDescripcionQuirurgica.ProHorF} //dataUser.ProHorF
                      disabled={true}
                      name='horaFinal'
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  
                </div>
              </div>
              <div className="flex-auto overflow-y-auto relative px-1">
              <div className="flex flex-row py-2  text-left">
                <div className="w-1/2  px-1 text-left">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Quirófano
                    </label>
                    <input
                    disabled={true}
                      defaultValue={dataDescripcionQuirurgica.ConsDet} //dataUser.ProNcons
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/2  px-1 text-left">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      N° Cirugía
                    </label>
                    <input
                      disabled={true}
                      defaultValue={dataDescripcionQuirurgica.ProCirCod} //dataUser.ProCirCod
                      name='idCirugia'
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  </div>
              </div>
              <div className="flex-auto overflow-y-auto relative px-1">
                <div className="flex flex-row py-2  text-left">
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Dx. PreOperatorio Cód.
                    </label>
                    <input                      
                      value={passDataDiagnosticoPreoperatorio.CodDxPrPo}
                      onFocus={handleOnclickPrincipalDiagnosticoPreoperatorio}
                      name='codigoPreOperatorio'
                      autoComplete='off'
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                      readOnly
                    />
                    <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                      {errorDiagnosticoPreoperatorio}
                    </label>
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Dx. PreOperatorio
                    </label>
                    <input
                      disabled={true}
                      //defaultValue={passDataDiagnosticoPreoperatorio.nombreDiagnostico}
                      value={passDataDiagnosticoPreoperatorio.DMNomb}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Obser
                    </label>
                    <input
                      defaultValue={dataUpdate.DesObsDxE}
                      name="obserPreoperatorio"
                      autoComplete="off"
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/4  px-4 ">
                    <label className="form-label block mb-2 text-gray-900 font-medium ">
                      Otros Dx PreOperatorio
                    </label>
                    <button
                      type="button"
                      onFocus={handleOnclickDiagnosticoDescripcionPreoperatorio}
                      className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    >
                      Otros Dx PreOperatorio
                    </button>
                  </div>
                </div>
              </div>
              <div className="flex-auto overflow-y-auto relative px-1">
                <div className="flex flex-row py-2  text-left">
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Dx. PostOperatorio Cód.
                    </label>
                    <input
                      value={passDataDignosticoPostoperatorio.codigoDiagnostico}
                      onFocus={handleOnclickPrincipalListaDiagnosticoPosoperatorio}
                      name='codigoPostOperatorio'
                      autoComplete='off'
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                      readOnly
                    />
                    <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                      {errorDigagnosticoPostoperatorio}
                    </label>
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Dx. PostOperatorio
                    </label>
                    <input
                      disabled={true}
                      value={passDataDignosticoPostoperatorio.nombreDiagnostico}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Obser
                    </label>
                    <input
                     defaultValue={dataUpdate.DesObsDxS}
                      type="text"
                      name="obserPostoperatorio"
                      autoComplete="off"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/4  px-4 ">
                    <label className="form-label block mb-2 text-gray-900 font-medium ">
                      Otros Dx PostOperatorio
                    </label>
                    <button
                      type="button"
                      onClick={
                        handleOnclickDiagnosticoDescripcionPostOperatorio
                      }
                      className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    >
                      Otros Dx PostOperatorio
                    </button>
                  </div>
                </div>
              </div>

              <div className="flex-auto overflow-y-auto relative px-1">
                <div className="flex flex-row py-2  text-left">
                  
                  
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Fecha Inicial
                    </label>
                    <input
                      defaultValue={dataUpdate.FECINICIR? dataUpdate.FECINICIR.split(' ')[0]:fechaActual()}
                      disabled={true}
                      type="date"
                      className="form-control block w-full px-1 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                      {/* {errorFechaInicial} */}
                    </label>
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Hora Inicial
                    </label>
                    <input
                      onChange={handleOnchangeHoraInicial}
                      defaultValue={dataUpdate.HorIniCir}
                      name='horaFinalDX'
                      type="time"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                      {errorHoraInicial}
                    </label>
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Fecha Final
                    </label>
                    <input
                      defaultValue={dataUpdate.FECFINCIR? dataUpdate.FECFINCIR.split(' ')[0]:fechaActual()}
                      disabled={true}
                      type="date"
                      className="form-control block w-full px-1 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                      {/* {errorFechaFinal} */}
                    </label>
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Hora Final
                    </label>
                    <input
                      onChange={handleOnchangeHoraFinal}
                      defaultValue={dataUpdate.HorFinCir}
                      name='holaFinalDX'
                      type="time"
                      className="form-control block w-full px-1 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                      {errorHoraFinal}
                    </label>
                  </div>
                </div>
              </div>
              <div className="flex-auto overflow-y-auto relative px-1">
                <div className="flex flex-row py-2  text-left">
                  <div className="w-1/4  px-1">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                      Tipo Anestesia
                    </label>
                    <div className="">
                      <select
                        value={dataTipoAnestesia}
                        onChange={handleOnChangeTipoAnestesia}
                        name="tipoAnestesia"
                        className="bg-[#eaebec] form-select block  w-full px-2 py-0.5 text-base font-normal text-gray-700  bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                        aria-label="Default select example"
                      >
                        <option value="3">EPIDURAL</option>
                        <option value="1">GENERAL</option>
                        <option value="2">LOCAL</option>
                        <option value="4">SEDACIÓN</option>
                      </select>
                    </div>
                  </div>
                  <div className="w-1/4  px-1">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                      Herida
                    </label>
                    <div className="">
                      <select
                        onChange={handleOnchangeHerida}
                        value={dataTipoHerida}
                        name='herida'
                        className="form-select block  w-full px-2 py-0.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                        aria-label="Default select example"
                      >
                        {/* <option value="Sin Seleccionar">Sin Seleccionar</option> */}
                        <option value="1">Limpia</option>
                        <option value="2">Limpia Contaminada</option>
                        <option value="3">Contaminada</option>
                        <option value="4">Sucia</option>
                      </select>
                    </div>
                    {/* <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                      {errorTipoHerida}
                    </label> */}
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Tiempo Clamp Min
                    </label>
                    <input
                      defaultValue={dataUpdate.TieClamp}
                      type="number"
                      name="tempoClampMin"
                      autoComplete="off"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Tie. Perfusión Min
                    </label>
                    <input
                      defaultValue={dataUpdate.TiePer}
                      type="number"
                      autoComplete="off"
                      name="tiePerfusionMin"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
              <div className="flex-auto overflow-y-auto relative px-1">
                <div className="flex flex-row py-2  text-left">
                  
                  
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Vía
                    </label>
                    <div className="">
                      <select
                        //defaultValue={'U'}
                        value={dataVia}
                        onChange={handleOnchageVia}
                        name='viaUBD'
                        className="form-select block  w-full px-2 py-0.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                        aria-label="Default select example"
                      >
                        <option value="U">Unica via</option>
                        <option value="B">Bilateral</option>
                        <option value="D">Diferente Via</option>
                      </select>
                    </div>
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Indice riesgo NNIS
                    </label>
                    <input
                     defaultValue={dataUpdate.DesInNNIS}
                    autoComplete="off"
                    name="indiceRiesgoNNIS"
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Reintervención
                    </label>
                    <input
                      //checked={isComplicaciones}
                     //onChange={handleOnchangeIsComplicaciones}
                      className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                      type="checkbox"
                     // name="valoracionPreanestesica"
                      id="flexCheckDefault"
                      //checked={reqValoracionPreanestesica}
                      //onChange={handleOnchangeReqValoracionPreanestesica}
                    />
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Volumen Sangrado
                    </label>
                    <input
                    defaultValue={dataUpdate.CanSan}
                      autoComplete="off"
                      name="cntSangrado"
                      type="number"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
              
              {/* <div className="flex-auto  relative px-1">
                <div className="flex flex-row   text-left">
                <div className="w-1/2  px-1">
                    
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium mt-16">
                      Hallazgos
                    </label>
                  </div>
                  <div className="w-1/2  px-1 ">
                    <label className="form-label block mb-2 text-gray-900 font-medium ">
                      Descripción Qx
                    </label>
                    <div className="pb-2">
                    
                   <Select
                   defaultValue={{ label:'Seleccionar una descripcion qx', value:'empty'}}
                   options={descripcionSelect.map(item=> ({label:item.DQxClv, value:item.DQxCod}))}
                   onChange={handleOnchangeDescripcionQXSelect}
                   styles={customStyles}

                   />
                     
                    </div>
                    <label className="form-label inline-block  text-red-900 text-sm font-medium">
                      {errorDescripciónQx}
                    </label>
                    
                  </div>
                </div>
              </div> */}
              {/* <div className="flex-auto  relative px-1">
                <div className="flex flex-row   text-left">
                  <div className="w-1/2  px-1 mt-2">
                    
                    <textarea
                     
                      defaultValue={dataUpdate.DesHalEnc}
                      name="hallazgos"
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                          transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      id="exampleFormControlTextarea1"
                      rows="15"
                      placeholder=""
                    ></textarea>
                  </div>
                  <div className="w-1/2  px-1 ">
                    
                    <div className="pb-2">
                    
                   
                     
                    </div>
                    
                    <textarea
                      onChange={handleOnchangeTextDescripcion}
                      value={textAreaQx}
                      name='textAreaDes'
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                          transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      id="exampleFormControlTextarea1"
                      rows="15"
                      placeholder=""
                    ></textarea>
                  </div>
                </div>
              </div> */}
              {
                datalistMedicoSinDuplicados.map((medico, index)=>(
                <div key={index}>
                <div className="bg-[#9e56fe] mt-3">
                <label className="form-label inline-block p-2 text-white font-medium text-center text-xl">
                     Cirujano - {medico.MMNomM}
                </label>
                </div>
                <div className="flex flex-row py-1  text-left mb-3">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Código Cirujano
                    </label>
                    <input
                      disabled={true}
                      defaultValue={medico.MedCod} //dataUser.ProCirCod
                      
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Nombre Cirujano
                    </label>
                    <input
                    defaultValue={medico.MMNomM} 
                    disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Especilidad Cirujano
                    </label>
                    <input
                    defaultValue={medico.MENomE}
                    disabled={true}
                    
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
              
              <div className="flex-auto  relative px-1">
                <div className="flex flex-row   text-left">
                <div className="w-1/2  px-1">
                   
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium mt-16">
                      Hallazgos 
                    </label>
                  </div>
                  <div className="w-1/2  px-1 ">
                    <label className="form-label block mb-2 text-gray-900 font-medium ">
                      Descripción Qx 
                    </label>
                    <div className="pb-2">
                    
                    <Select
  defaultValue={{ label: 'Seleccionar una descripcion qx', value: 'empty' }}
  options={descripcionSelect.map((item) => ({ label: item.DQxClv, value: item.DQxCod }))}
  onChange={(selectedOption) => handleOnchangeDescripcionQXSelect2(selectedOption, medico)}
  styles={customStyles}
  isDisabled={(seleccionarMedico.MedCod?.trim() ?? '') !== (medico.MedCod?.trim() ?? '')}
/>
                     
                    </div>
                    {/* <label className="form-label inline-block text-red-900 text-sm font-medium">
              {(!textAreasValues[medico.MedCod]?.trim() && seleccionarMedico.MedCod.trim() === medico.MedCod.trim()) && 'Debe ingresar una Descripción de la Cirugía'}
            </label> */}
                    {/* <label className="form-label inline-block text-red-900 text-sm font-medium">
  {errorDescripciónQx2}
</label> */}

                  </div>
                </div>
              </div>
              <div className="flex-auto  relative px-1">
                <div className="flex flex-row   text-left">
                  <div className="w-1/2  px-1 mt-2">                    
                  <textarea
  value={hallazgosPorMedico[medico.MedCod] ?? ''}
  disabled={seleccionarMedico.MedCod.trim() !== medico.MedCod.trim()}
  onChange={(event) => hangleOnchangeHallazgos2(event, medico)}
  name="hallazgos2"
  className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
  id="exampleFormControlTextarea1"
  rows="15"
  placeholder=""
></textarea>

                  </div>
                  <div className="w-1/2  px-1 ">                    
                    <div className="pb-2"> 
                    </div>                   
                    
<textarea
  disabled={seleccionarMedico.MedCod.trim() !== medico.MedCod.trim()}
  onChange={(e) => handleOnchangeTextDescripcion2(e, medico)}
  value={textAreasValues[medico.MedCod] ?? ''}
  name='textAreaDes2'
  className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
  id="exampleFormControlTextarea1"
  rows="15"
  placeholder=""
></textarea>



                  </div>
                </div>
              </div>
                </div>
                
              ))
              }
              
              <div className="bg-[#9e56fe] mt-3">
                <label className="form-label inline-block mb-2 text-white font-medium text-center text-2xl">
                Complicación
                </label>
              </div>
              
              <div className="flex-auto overflow-y-auto relative px-4">
                <div className="flex flex-row py-2  text-left">
                  <div className="w-1/2 px-1">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                      Complicaciones presentes en la Cirugía?
                    </label>
                    <input
                      checked={isComplicaciones}
                      onChange={handleOnchangeIsComplicaciones}
                      className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                      type="checkbox"
                      name="valoracionPreanestesica"
                      id="flexCheckDefault"
                      
                    />
                  </div>
                </div>
              </div>
              <div className=" px-4 ">
                <textarea
                  
                  disabled={!isComplicaciones}
                  defaultValue={dataUpdate.DesCom}
                  name="complicacionesTextArea"
                  onChange={handleOnchangeComplicaciones}
                  className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                          transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  id="exampleFormControlTextarea1"
                  rows="5"
                  placeholder=""
                ></textarea>
              </div>

              <div className="flex-auto overflow-y-auto relative p-2">
                <div className="flex flex-row py-2  text-left">
                  <div className="w-1/4  px-2 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Cod. Dx. Comp.
                    </label>
                    <input
                      defaultValue={passDataDiagnosticoCodDxCom.codigoDiagnostico}
                      disabled={!isComplicaciones}
                      autoComplete="off"
                      onFocus={handleOnclickSeleccionDiagnosticoCodDxCom}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                      readOnly
                    />
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium pt-4"></label>
                    <input
                      defaultValue={passDataDiagnosticoCodDxCom.nombreDiagnostico}
                      disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label block mb-2 text-gray-900 font-medium pt-6"></label>
                    <button
                      //onClick={handleOnclickAgregarDiagnosticoCodDxCom}
                      onClick={handleOnclickCodDxComp}
                      disabled={!isComplicaciones}
                      ///defaultValue={'Agregar'}
                      type="button"
                      //onClick={handleClickDataCirugia}
                      className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    >
                      Agregar
                    </button>
                  </div>
                </div>
              </div>
              <div className="">
                <div className="flex flex-col">
                  <div className="overflow-x-auto ">
                    <div className="py-2 inline-block min-w-full sm:px-1 ">
                      <div className="overflow-hidden">
                        <table className="min-w-full text-center">
                          <thead className="border-b bg-gray-200">
                            <tr>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-6 py-4"
                              >
                                Código Diagnóstico
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-6 py-4"
                              >
                                Nombre Diagnóstico
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              dataListComplicaciones.map((item,index)=>(
                                <TablaCodDxCompDQ key={index} item={item}/>
                              ))
                            }
                            {/* <tr className="border-b">
                              <td className="text-xs font-medium py-2 whitespace-pre-wrap">
                                0001
                              </td>
                              <td className="text-xs font-medium py-2 whitespace-pre-wrap">
                                APENDICECTOMIA VIA ABIERTA
                              </td>
                            </tr> */}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="flex-auto overflow-y-auto relative px-4">
                <div className="flex flex-row py-2  text-left">
                  <div className="w-1/3 px-4">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                      Tejidos para patologia?
                    </label>
                    <input
                      className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                      type="checkbox"
                      name="valoracionPreanestesica"
                      id="flexCheckDefault"
                      
                    />
                    <div className="inline-block px-8">
                      <button
                        type="button"
                        onClick={handleOnclickPatologia}
                        className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                      >
                        Tejidos patologia
                      </button>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
                <button
                  type="button"
                  onClick={handleCancelClick}
                  className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  //onClick={handleClickDataCirugia}
                  className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                >
                  Guardar
                </button>
              </div>
            </form>
            </div>
            <div className="flex-auto overflow-y-auto relative ">
            <div className={openTab === 2 ? "block" : "hidden"} id="link2">
              <ModalProcedimientoDQX item={item} setmodalOnDescripcionQuirurgica={setmodalOnDescripcionQuirurgica} setactualizarTablaProcedimientos={setactualizarTablaProcedimientos} handleCancelClickListaProcedimientos={handleCancelClickListaProcedimientos}/>
            </div>
            </div>
            </>
            
          </div>
        </div>
        {
            loading? 
            
            <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
        :
        null
          }
      </div>
      {modalOnDiagnosticoDescripcionPreoperatorio ? (
        <ModalDiagnosticosDescripcionQxPreoperatorio
          setmodalOnDiagnosticoDescripcionPreoperatorio={
            setmodalOnDiagnosticoDescripcionPreoperatorio
          }
          procir={dataUser.ProCirCod}
          codigoMedico= {codigoEspecialidadM.ProPerSep}
        />
      ) : null}
      {modalOnDiagnosticoDescripcionPostOperatorio ? (
        <ModalDiagnosticosDescripcionPostOperatorio
          setmodalOnDiagnosticoDescripcionPostOperatorio={
            setmodalOnDiagnosticoDescripcionPostOperatorio
          }
          procir={dataUser.ProCirCod}
          codigoMedico= {codigoEspecialidadM.ProPerSep}
        />
      ) : null}
      {modalOnClickPatologia? <ModalTejidosPatologiaDecripcionQX setmodalOnClickPatologia={setmodalOnClickPatologia}/>:null}
      {modalOnPrincipalListaDiagnosticoPreoperatorio?<ModalPrincipalListaDiagnosticosPreoperatorio setmodalOnPrincipalListaDiagnosticoPreoperatorio={setmodalOnPrincipalListaDiagnosticoPreoperatorio} passDataDiaPreoperatorio={passDataDiaPreoperatorio}/>:null}
      {modalOnPrincipalListaDiagnosticoPosoperatorio?<ModalPrincipalListaDiagnosticosPosoperatorio setmodalOnPrincipalListaDiagnosticoPosoperatorio={setmodalOnPrincipalListaDiagnosticoPosoperatorio} passDataDiaPostoperatorio={passDataDiaPostoperatorio}/>:null}
      {modalOnSeleccionDiagnosticoCodDxCom? <ModalListaDeSeleccionDignosticoCodDxCom setmodalOnSeleccionDiagnosticoCodDxCom={setmodalOnSeleccionDiagnosticoCodDxCom} passDataDiaCodDxCom={passDataDiaCodDxCom}/>:null}
      {modalOnMensajeComplicacion? <ModalMensajeComplicacion setmodalOnMensajeComplicacion={setmodalOnMensajeComplicacion}/>:null}
      {modalOnGuardadoExitosamente? <DescripcionQuirurgicaSuccessFull setmodalOnGuardadoExitosamente={setmodalOnGuardadoExitosamente} setOpenTab={setOpenTab} item={item} seleccionarMedico={seleccionarMedico}/>:null}
      {modalOnError? <ErrorDescripcionQuirurgica setmodalOnError={setmodalOnError} errorDiagnosticoPreoperatorio={errorDiagnosticoPreoperatorio} errorDigagnosticoPostoperatorio={errorDigagnosticoPostoperatorio} errorTipoHerida={errorTipoHerida} errorHoraInicial={errorHoraInicial} errorHoraFinal={errorHoraFinal} errorDescripciónQx={errorDescripciónQx} errorDescripciónQx2={errorDescripciónQx2}/>:null}
      {modalOnDescripcionQXRealizada? <ModalDescripcionQXYaSeRealizo setmodalOnDescripcionQXRealizada={setmodalOnDescripcionQXRealizada}/>:null}
    </>
  );
};

export default function ModalDescripcionCirugiaMedico({ setmodalOnDescripcionQuirurgica,  item, dataRealizada,setactualizarTablaProcedimientos,passChildCambioDeEstado,seleccionarMedico,passDataActualizarDescripcionQX,handleCancelClickListaProcedimientos, datalistMedico }) {
  //const [dataArrayCirujanos, setdataArrayCirujanos]=useState([])
  //quitar cirujanos repetidos
  const datalistMedicoSinDuplicados = datalistMedico.reduce((acc, current) => {
    const x = acc.find((item) => item.MedCod === current.MedCod);
    if (!x) {
      return acc.concat([current]);
    } else {
      return acc;
    }
  }, []);
  return (
    <DescripcionCirugiaMedicoTabs
      setmodalOnDescripcionQuirurgica={setmodalOnDescripcionQuirurgica}
      color="[#437cdc]"
      item={item}
      dataRealizada={dataRealizada}
      setactualizarTablaProcedimientos={setactualizarTablaProcedimientos}
      passChildCambioDeEstado={passChildCambioDeEstado}
      seleccionarMedico={seleccionarMedico}
      passDataActualizarDescripcionQX={passDataActualizarDescripcionQX}
      handleCancelClickListaProcedimientos={handleCancelClickListaProcedimientos}
      datalistMedico={datalistMedico}
      datalistMedicoSinDuplicados={datalistMedicoSinDuplicados}
    />
  );
}
